/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import styled from "styled-components";

export const Content = styled.p`
    margin-top: 1.5rem;
`;

export const Container = styled.div`
    position: relative;
    max-width: 800px;
`;

export const TextWrapper = styled.div`
    border-radius: 3rem;
    max-width: 650px;
`;

export const Title = styled.div`
    font-size:24px;
    text-align:center;
    padding:5px;
`;
